import { render, staticRenderFns } from "./GlobalNewsCreate.vue?vue&type=template&id=baf141c2&scoped=true"
import script from "./GlobalNewsCreate.vue?vue&type=script&lang=js"
export * from "./GlobalNewsCreate.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewsCreate.vue?vue&type=style&index=0&id=baf141c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf141c2",
  null
  
)

export default component.exports